export const HEADER_TYPES = {
  SET_ADDRESS: 'SET_ADDRESS',
  SET_TIME: 'SET_TIME',
  SET_SEARCH: 'SET_SEARCH',
  SET_IS_SEARCH_VISIBLE: 'SET_IS_SEARCH_VISIBLE',
  SET_IS_DELIVERY_INFO_VISIBLE: 'SET_IS_DELIVERY_INFO_VISIBLE',
};

export const RESTAURANT_LIST_TYPES = {
  SET_RESTAURANT_LIST_DATA: 'SET_RESTAURANT_LIST_DATA',
  TOGGLE_IS_LOADING: 'TOGGLE_IS_LOADING',
  TOGGLE_IS_ERROR: 'TOGGLE_IS_ERROR',
};

export const RESTAURANT_TYPES = {
  SET_RESTAURANT_DATA: 'SET_RESTAURANT_DATA',
  TOGGLE_IS_LOADING: 'TOGGLE_IS_LOADING',
  TOGGLE_IS_ERROR: 'TOGGLE_IS_ERROR',
};

export const MENU_ITEM_TYPES = {
  SET_MENU_ITEM_DATA: 'SET_MENU_ITEM_DATA',
  TOGGLE_MENU_ITEM_IS_LOADING: 'TOGGLE_MENU_ITEM_IS_LOADING',
  TOGGLE_MENU_ITEM_IS_ERROR: 'TOGGLE_MENU_ITEM_IS_ERROR',
};
